module.exports = __webpack_public_path__ + "51c94695b987d84db01e54e91fb8cf90.woff";